export default import.meta.ROLLDOWN_FILE_URL_OOfq8fDOe4llJwFUg47j2g